// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"836":"5e843e6648162e5b","888":"61eb6a31736eeffb","906":"5e843e6648162e5b"}[chunkId] + ".css";
};